<template>
  <div class="feuerwehrVerwaltung">
    <transition-group name="slide-up" tag="div" appear>
        <h1 class="ueberschrift">Feuerwehr</h1>
        <h2 class="unterueberschrift">Verwalten Sie die Einstellungen Ihrer Feuerwehr.</h2>
        <div class="card" key="feuerwehr">
            <div class="cardIconBox"><i class="cardIcon fa">&#xf1ad;</i></div>
            <div class="cardContentBox">
                <h3 class="cardHeading">Name der Feuerwehr</h3>
                <div class="cardContent">
                    <div class="inputWrapper">
                        <input type="text" v-model="bezeichnung" @keyup.enter="this.setName(this.bezeichnung)">
                        <button @click="this.setName(this.bezeichnung)" class="editButton fa">&#xf044;</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="card" key="standort">
            <div class="cardIconBox"><i class="cardIcon fa">&#xf041;</i></div>
            <div class="cardContentBox">
                <h3 class="cardHeading">Stützpunktstandort</h3>
                <div class="cardContent">
                    <div class="inputWrapper">
                        <input type="text" readonly="true" :value="this.ort">
                    </div>
                    <div class="locationMap" :class="this.mapExpanded?'mapExpanded':'mapClosed'">
                        <FeuerwehrAuswahl @locationSelected="this.locationSelected" :positionExtern="this.position" class="auswahl" :mapExpanded="this.mapExpanded" :setMarkerActive="this.mapExpanded"/>
                        <button @click="this.mapExpanded = !this.mapExpanded; (!this.mapExpanded?this.setPositionDB(this.breitengrad, this.laengengrad):'')" class="changeLocation"><span v-if="!this.mapExpanded">Standort bearbeiten</span><span v-if=this.mapExpanded>Standort speichern</span></button>
                    </div>
                </div>
            </div>
        </div>
        <div class="card" key="connections">
            <div class="cardIconBox"><i class="cardIcon fa">&#xf055;</i></div>
            <div class="cardContentBox">
                <h3 class="cardHeading">Verknüpfte Feuerwehren</h3>
                <div class="cardContent">
                    <p class="hintText">
                        Teilen Sie Ihre Hydranten und Leitungskarte mit anderen Feuerwehren
                    </p>
                    <div class="verknuepfteFeuerwehr" v-for="partner in this.partnerfeuerwehren" :key="partner.feuerwehrID">
                        <div class="verknuepfungName">
                            {{ partner.name }}
                        </div>
                        <button class="verknuepfungEntfernen fa" @click="this.removePartner(partner.feuerwehrID)">
                            &#xf1f8;
                        </button>
                    </div>
                    <div class="inputWrapper">
                        <input type="text" v-model="vernkuepfungsCode" placeholder="Verknüpfungscode eingeben" autocomplete="off" name="no-autofill">
                        <button class="addButton fa" @click="this.addPartner(vernkuepfungsCode)">&#xf067;</button>
                    </div>
                    <div class="inputWrapper">
                        <input type="text" style="color: darkgreen" value="Eigenen Verknüpfungscode kopieren" readonly @click="this.copyCode()">
                        <button class="addButton fa" style="color: darkgreen" @click="this.copyCode()">&#xf0c5;</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="card" key="password">
            <div class="cardIconBox"><i class="cardIcon fa">&#xf023;</i></div>
            <div class="cardContentBox">
                <h3 class="cardHeading">Passwortschutz für Benutzerfreischaltung</h3>
                <div class="cardContent">

                    <p class="hintText">
                        Erstellen Sie ein Passwort für die Freischaltung neuer Benutzer. (Eingabe mit Enter bestätigen)
                    </p>

                    <div class="inputWrapper">
                        <input 
                            :type="showPassword ? 'text' : 'password'" 
                            v-model="freischaltPasswort"
                            placeholder="Freischalt‑Passwort"
                            autocomplete="new-password"
                            @keyup.enter="this.setFreischaltPasswort(freischaltPasswort)"
                        >
                        <button class="showButton fa" @click="this.showPassword = !this.showPassword">
                            {{!showPassword ? '&#xf06e;':'&#xf070;'}}
                        </button>
                    </div>

                    <div class="toggleRow">
                        <span><b>{{ passwortAktiv ? 'Aktiviert' : 'Deaktiviert' }}</b></span>

                        <label class="switch">
                            <input type="checkbox" v-model="passwortAktiv" @change="this.setFreischaltPasswortAktiv(passwortAktiv)">
                            <span class="slider"></span>
                        </label>
                    </div>

                </div>
            </div>
        </div>
        <div class="card" key="delete">
            <div class="cardIconBox"><i class="cardIcon fa">&#xf023;</i></div>
            <div class="cardContentBox">
                <h3 class="cardHeading">Feuerwehr löschen</h3>
                <div class="cardContent">
                    <p class="hintText">
                        Durch das Löschen Ihrer Feuerwehr werden alle Daten unwiderruflich gelöscht. Bitte stellen Sie sicher, dass Sie ein Backup aller wichtigen Daten haben, bevor Sie fortfahren.
                    </p>
                    <button class="deleteButton" style="background-color: #C00000" @click="this.removeFeuerwehr()">Feuerwehr löschen</button>

                </div>
            </div>
        </div>
    </transition-group>
    <br><br>
  </div>
</template>
  
<script>
import { Feuerwehr } from '@/backend_controller/feuerwehr';
import FeuerwehrAuswahl from '../Login/FeuerwehrAuswahl.vue';
import axios from 'axios';
import { Partnerschaft } from '@/backend_controller/partnerschaft';
import Swal from 'sweetalert2'


export default {
    name: 'feuerwehrVerwaltung',
    components: {
        FeuerwehrAuswahl
    },
    data() {
      return{
        mapExpanded: false,

        freischaltPasswort: '',
        passwortAktiv: true,
        showPassword: false,
        laengengrad: null,
        breitengrad: null,
        ort: 'Wird geladen...',
        position: null,
        bezeichnung: 'Wird geladen...',
        feuerwehr: {},
        partnerfeuerwehren: []
      }
    },
    methods:{
        locationSelected(position){
            this.laengengrad = position.lng;
            this.breitengrad = position.lat;
            if(position.address == null){
                return;
            }
            this.ort = position.address.street + ' ' + position.address.house_number + ', ' + position.address.postcode + ' ' + position.address.city;
        },
        async addPartner(feuerwehrKonvKey){
            let partner = await Feuerwehr.getFeuerwehrByFeuerwehrKonvKey(feuerwehrKonvKey);
            if(partner == false){
                Swal.fire("Fehler","Es konnte keine Feuerwehr mit diesem Verknüpfungscode gefunden werden. Bitte überprüfen Sie Ihre Eingabe.","error");
                return;
            }
            let response = await Partnerschaft.add({partner1: this.feuerwehr.feuerwehrID, partner2: partner.feuerwehrID});
            if(response == false){
                Swal.fire("Fehler bei der Verknüpfung","Versuchen Sie es später erneut","error");
            } else{
                this.vernkuepfungsCode = "";
                Swal.fire("Verknüpfung erfolgreich","Sie sind jetzt nun mit der Feuerwehr " + partner.name + " verknüpft. Ihre Zusammenarbeit kann nun beginnen!","success");
                await this.getPartnerschaften(this.feuerwehr.feuerwehrID);
            }
        },
        async removePartner(partnerID){
            await Swal.fire({
                title: 'Verknüpfung entfernen',
                text: "Möchten Sie die Verknüpfung mit dieser Feuerwehr wirklich entfernen? Alle Informationen über die verknüpfte Feuerwehr gehen dadurch verloren.",
                icon: 'warning',
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ja, entfernen!',
                cancelButtonText: 'Abbrechen'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    let response = await Partnerschaft.delete({partner1: this.feuerwehr.feuerwehrID, partner2: partnerID});
                    if(response == false){
                        Swal.fire("Fehler beim Entfernen der Verknüpfung","Versuchen Sie es später erneut","error");
                    } else{
                        Swal.fire("Verknüpfung erfolgreich entfernt","Die Verknüpfung wurde soeben entfernt","success");
                        await this.getPartnerschaften(this.feuerwehr.feuerwehrID);
                    }
                }
            })
        },
        async removeFeuerwehr(){
            await Swal.fire({
                title: 'Feuerwehr löschen',
                text: "Möchten Sie Ihre Feuerwehr wirklich löschen? Alle Daten Ihrer Feuerwehr gehen dadurch verloren.",
                icon: 'warning',
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ja, löschen!',
                cancelButtonText: 'Abbrechen'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    let response = await Feuerwehr.delete(this.feuerwehr.feuerwehrID);
                    if(response == false){
                        Swal.fire("Fehler beim Löschen der Feuerwehr","Versuchen Sie es später erneut","error");
                    } else{
                        await Swal.fire("Feuerwehr erfolgreich gelöscht","Ihre Feuerwehr wurde soeben gelöscht","success");
                        localStorage.clear();
                        this.$router.push('/');
                    }
                }
            })
        },
        async copyCode(){
            await navigator.clipboard.writeText(this.feuerwehr.konvKey);
            Swal.fire("Verknüpfungscode erfolgreich kopiert","Nun können Sie den Code einer anderen Feuerwehr für eine Zusammenarbeit schicken","success")
        },
        async getPartnerschaften(feuerwehrID){
            let response = await Partnerschaft.getPartnerfeuerwehren(feuerwehrID);
            if(response!==false){
                this.partnerfeuerwehren = response;
                console.log(this.partnerfeuerwehren);
            }
        },
        async setName(name){
            let response = await Feuerwehr.setName(this.$route.params.id.replace(":", ""),name)

            if(response == false){
                Swal.fire("Fehler beim Speichern!","Bitte versuchen Sie es später nochmal.","error");
            } else{
                Swal.fire("Erfolgreich gespeichert","Ihre Änderungen wurden soeben übernommen","success");
            }
        },
        async setPositionDB(positionX, positionY){
            let response = await Feuerwehr.setPosition(this.$route.params.id.replace(":", ""),positionX,positionY)

            if(response == false){
                Swal.fire("Fehler beim Speichern!","Bitte versuchen Sie es später nochmal.","error");
            } else{
                Swal.fire("Erfolgreich gespeichert","Ihre Änderungen wurden soeben übernommen","success");
            }
        },
        async setFreischaltPasswort(passwort){
            let response = await Feuerwehr.setFreischaltPasswort(this.$route.params.id.replace(":", ""),passwort)

            if(response == false){
                Swal.fire("Fehler beim Speichern!","Bitte versuchen Sie es später nochmal.","error");
            } else{
                Swal.fire("Erfolgreich gespeichert","Ihre Änderungen wurden soeben übernommen","success");
            }
        },
        async setFreischaltPasswortAktiv(aktiv){
            if(aktiv == true && (this.freischaltPasswort == "" || this.freischaltPasswort == undefined || this.freischaltPasswort == null)){
                Swal.fire("Fehler beim Speichern!","Bitte füllen Sie das Freischalt-Passwort um fortzufahren","error");
                this.passwortAktiv = false;
                return;
            }

            let response = await Feuerwehr.setFreischaltPasswortAktiv(this.$route.params.id.replace(":", ""),aktiv)

            if(response == false){
                Swal.fire("Fehler beim Speichern!","Bitte versuchen Sie es später nochmal.","error");
            } else{
                Swal.fire("Erfolgreich gespeichert","Ihre Änderungen wurden soeben übernommen","success");
            }
        },
        async getFeuerwehr() {
            let feuerwehr = {};
            let response = await Feuerwehr.getFeuerwehrByKonvKey(this.$route.params.id.replace(":", ""));
            if(response !== false){
                var lat = response.positionX;
                var long = response.positionY;
                console.log(response);
                this.laengengrad = lat;
                this.breitengrad = long;
                this.bezeichnung = response.name;
                this.freischaltPasswort = response.freischaltPasswort;
                this.passwortAktiv = response.freischaltPasswortAktiv == 0?false:true;
                this.feuerwehr = response;
            } 
            if(this.laengengrad !== undefined){
                localStorage.setItem('Feuerwehr', JSON.stringify(feuerwehr));
                this.setPosition();
            } else{
                let feuerwehr = JSON.parse(localStorage.getItem('Feuerwehr'));
                this.laengengrad = feuerwehr.positionX;
                this.breitengrad = feuerwehr.positionY;
                this.bezeichnung = feuerwehr.name;
                this.passwortAktiv = feuerwehr.freischaltPasswortAktiv;
                console.log(feuerwehr)
                this.setPosition();
            }
        },
        setPosition(){
            console.log(this.laengengrad);
            if(this.laengengrad == undefined){
                return;
            }
            this.position = {
                lat: Number(this.laengengrad.toFixed(6)),
                lng: Number(this.breitengrad.toFixed(6))
            };
        }
    },
    async created() {
        await this.getFeuerwehr();
        await this.getPartnerschaften(this.feuerwehr.feuerwehrID);
    },
    mounted(){
        this.setPosition();
    }
}
</script>

<style lang="scss" scoped>
.feuerwehrVerwaltung {
    height: 97vh;
    width: 100vw;
    background-color: rgb(248, 248, 248);
    position: fixed;
    overflow-y: auto;
}

.ueberschrift{
    width: 90vw;
    margin-left: auto;
    margin-right: auto;
    margin-top: 6.5rem;
    font-size: x-large;
    text-align: left;
    //border: solid rgb(236, 236, 236) 1px;
    //border-radius: 8px;
    //cursor: default;
}

.unterueberschrift{
    width: 90vw;
    margin-left: auto;
    margin-right: auto;
    text-align: left;
    font-size: small;
    font-weight:normal;
}

.card{
    margin-left: auto;
    margin-right: auto;
    width: 90vw;
    background-color: white;
    border: solid rgb(236, 236, 236) 1px;
    border-radius: 8px;
    cursor: default;
    height: auto;
    min-height: 3rem;
    display: flex;
    padding-bottom: 0.6rem;
    margin-bottom: 0.7rem;

    .cardIconBox{
        padding-top: 0.6rem;
        padding-left: 0.6rem;
        padding-right: 0.6rem;

        .cardIcon{
            font-size: x-large;
        }
    }

    .cardContentBox{
        flex: 1;
        .cardHeading{
            font-size: medium;
            margin-top: 0;
            padding-top: 0.8rem;
            text-align: left;
            margin-bottom: 0.6rem;
        }

        .cardContent {
            width: 95%;
            .inputWrapper {
                position: relative;
                width: 100%;

                input {
                    width: 100%;
                    box-sizing: border-box;
                    padding-right: 2.2rem;
                    border: solid rgb(236, 236, 236) 1px;
                    border-radius: 3px;
                    padding: 0.4rem;

                    &:active {
                        border: solid rgb(236, 236, 236) 1px;
                    }
                }

                .editButton, .addButton, .showButton {
                    position: absolute;
                    right: 0rem;
                    top: 50%;
                    transform: translateY(-50%);
                    border: none;
                    background: none;
                    cursor: pointer;
                    font-size: 1rem;
                    padding: 0;
                    height: 100%;
                    width: auto;
                    aspect-ratio: 1 / 1;
                    border-left: solid rgb(236, 236, 236) 1px;

                    &:active {
                        transform: translateY(-50%) scale(0.95);
                    }
                }
            }

            .locationMap{
                margin-top: 0.6rem;
                border-radius: 12px;
                border: 1px solid #ddd;
                position: relative;
            }

            .mapExpanded{
                overflow:visible;
                height: auto;
            }

            .mapClosed{
                height: 8rem;
                overflow:hidden;
            }

            .changeLocation{
                position: absolute;
                bottom: -0.6rem;
                z-index: 1001;
                left: 50%;
                transform: translate(-50%, -50%);
                background-color: #C00000;
                color: white;
                border: solid rgb(236, 236, 236) 1px;
                border-radius: 8px;
                padding: 0.4rem;
                font-weight: lighter;
                font-size: small;
                cursor: pointer;
            }

            .deleteButton{
                background-color: #C00000;
                color: white;
                border: solid rgb(236, 236, 236) 1px;
                border-radius: 8px;
                padding: 0.4rem;
                font-weight: lighter;
                font-size: small;
                cursor: pointer;
            }

            .verknuepfteFeuerwehr{
                display: flex;
                justify-content: space-between;
                border: solid rgb(236, 236, 236) 1px;
                border-radius: 8px;
                padding-left: 0.6rem;
                align-items: center;
                margin-bottom: 0.2rem;
                height: 1.8rem;

                .verknuepfungName{
                    text-align: center;
                }

                .verknuepfungEntfernen{
                    height: 100%;
                    width: auto;
                    aspect-ratio: 1 / 1;
                    background-color: transparent;
                    border: none;
                    border-left: solid rgb(236, 236, 236) 1px;
                    font-size: 1em;
                    cursor: pointer;
                }
            }
        }
    }
}

.hintText {
    font-size: small;
    margin-bottom: 0.4rem;
    color: #666;
}

.toggleRow {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.6rem;
}

/* Toggle Switch */
.switch {
  position: relative;
  display: inline-block;
  width: 42px;
  height: 22px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background-color: #ccc;
  transition: .2s;
  border-radius: 20px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: .2s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #b00000;
}

input:checked + .slider:before {
  transform: translateX(20px);
}

</style>

<style lang="scss">
.mapClosed .map{
    height: 8rem !important;
}

.mapExpanded .map{
    height: 20rem !important;
}

.slide-up-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.slide-up-enter-to {
  opacity: 1;
  transform: translateY(0);
}

.slide-up-enter-active {
  transition: all 0.3s cubic-bezier(0.22, 1, 0.36, 1);
  //transition: all 0.6s ease-out;
}

/* Stagger-Effekt (Verzögerung) */
.slide-up-enter-active:nth-child(1) {
  transition-delay: 0.1s;
}
.slide-up-enter-active:nth-child(2) {
  transition-delay: 0.1s;
}
.slide-up-enter-active:nth-child(3) {
  transition-delay: 0.1s;
}
.slide-up-enter-active:nth-child(4) {
  transition-delay: 0.1s;
}
</style>
  
